import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as BaseThemeProvider } from 'styled-components';

const ThemeContext = createContext();

const ThemeProvider = ({ children, theme }) => {
  return (
    <ThemeContext.Provider value="">
      <BaseThemeProvider theme={theme}>{children}</BaseThemeProvider>
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  theme: PropTypes.object,
};

export { ThemeProvider };
